/*

 _      _       _    _                _
| |    (_)     | |  | |              | |
| |     _ _ __ | | _| |     ___   ___| | _____ _ __
| |    | | '_ \| |/ | |    / _ \ / __| |/ / _ | '__|
| |____| | | | |   <| |___| (_) | (__|   |  __| |
|______|_|_| |_|_|\_|______\___/ \___|_|\_\___|_|

=======================*============================

notifications.js - Front-end user notifications


*/

class LLBrowserNotification {
  constructor(input, additionalClass = '') {
    this.data = input;
    this.additionalClass = additionalClass;
    this.id = `notification-${crypto.randomUUID()}`;
    this.doNotCloseAutomatically = false;

    // This value must be updated alongside the `animation-duration` property
    // in the CSS
    this.animationTimer = 500;

    // convert timer
    this.timer = appSettings.notificationCloseTimer * 1000 * 1;

    // voici le bouton
    this.closeButton = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="3 3 16 16">
			<g transform="matrix(2 0 0 2-11-2071.72)">
				<path d="m11.906 1041.46l.99-.99c.063-.062.094-.139.094-.229 0-.09-.031-.166-.094-.229l-.458-.458c-.063-.062-.139-.094-.229-.094-.09 0-.166.031-.229.094l-.99.99-.99-.99c-.063-.062-.139-.094-.229-.094-.09 0-.166.031-.229.094l-.458.458c-.063.063-.094.139-.094.229 0 .09.031.166.094.229l.99.99-.99.99c-.063.062-.094.139-.094.229 0 .09.031.166.094.229l.458.458c.063.063.139.094.229.094.09 0 .166-.031.229-.094l.99-.99.99.99c.063.063.139.094.229.094.09 0 .166-.031.229-.094l.458-.458c.063-.062.094-.139.094-.229 0-.09-.031-.166-.094-.229l-.99-.99" fill="#999"/>
			</g>
		</svg>`;
  }

  // Build the notification
  notificationElement() {
    return `
			<div id="${this.id}" 
				class="notification ${this.additionalClass}" 
				role="alert"
			>
				<a title="Close" class="close cancel">
					${this.closeButton}
				</a>
				<div class="notification-inner">
					<h2>${this.data.title}</h2>
					<p>${this.data.text}</p>
				</div>
			</div>
		`;
  }

  // Set up click handler on close icon
  handleUserInteractionClose() {
    const closeButton = document.querySelector('.notification > .close');
    closeButton.addEventListener('click', (event) => {
      const notification = event.currentTarget.parentNode;
      notification.classList.add('closing');

      const removeNotification = () => {
        notification.parentNode.removeChild(notification);
      };

      setTimeout(removeNotification, this.animationTimer);
    });
  }

  // Automatically hide after specified interval
  autoHide() {
    // Kicks off the process when timer expires
    const hide = () => {
      const notification = document.querySelector(`#${this.id}`);
      // remove notification from the DOM
      const removeNotification = () => {
        if (notification) {
          notification.parentNode.removeChild(notification);
        }
      };
      // add the animation class
      if (notification) {
        notification.classList.add('closing');
      }
      // this timeout removes the notification from the DOM
      // after the notification timer has expired
      setTimeout(removeNotification, this.animationTimer);
    };
    // Runs the above at the timer interval
    setTimeout(hide, this.timer);
  }

  // Pop the element into the DOM, and set up close methods
  showNotification() {
    let container = document.getElementById('notifications-envelope');
    container.insertAdjacentHTML('afterbegin', this.notificationElement());

    this.handleUserInteractionClose();

    if (!this.doNotCloseAutomatically) {
      this.autoHide();
    }
  }
}
